import React from 'react';
import { IconStyled } from './style';

function Icon({ alt = 'Icon', height = 25, width = 25, ...rest }) {
  return <IconStyled alt={alt} height={height} width={width} {...rest} />;
}

export default Icon;
